/**
 * Die Rechnungszuordnung trägt in der DLL keine `[Caption(...)]`-Attribute —
 * das Grid zeigt für ihre Spalten den Feldnamen.
 */

import type { CaptionMap } from '../captions';

export const receiptAssignmentCaptions: CaptionMap = {};
